import type { ComponentProps } from 'react';

import { stroke, surface } from '@scaleaq/sui-tokens/colors';
import { css, styled } from 'styled-components';

export const StyledHeaderCell = styled.th<{ $divider?: boolean }>`
  ${({ $divider }) =>
    $divider &&
    css`
      border-left: 1px solid ${stroke.neutral['50']};
    `}
`;
export const StyledCell = styled.td<{ $align?: 'left' | 'center' | 'right' }>`
  vertical-align: middle;
  text-align: ${({ $align }) => $align ?? 'left'};
`;
export const StyledRow = styled.tr`
  height: 2.5rem;
`;
export const StyledTbody = styled.tbody`
  background-color: ${surface.sunken};
  tr:nth-child(even) {
    background-color: ${surface.default};
  }
`;
export const StyledTable = styled.table`
  border-collapse: collapse;
`;

type EllipsisProps = ComponentProps<'div'> & {
  $lineClamp?: number;
};

export const EllipsisLong = styled.div<EllipsisProps>`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ $lineClamp }) => $lineClamp ?? 1};
  overflow: hidden;

  text-overflow: ellipsis;
  word-break: break-all;
  overflow-wrap: anywhere;
`;
